// extracted by mini-css-extract-plugin
module.exports = {"root":"WsqnHIefUqGSSpTK_x3G","tldr":"maHiLx8i0DTza_UXR9_b"};